import React from "react";
import PropTypes from "prop-types";

const AddPicture = ({ addPicture }) => (
  <div className="DropZone__Preview" onClick={addPicture} role="button">
    <div className="DropZone__Preview--box">
      <div className="DropZone__Preview--add" />
    </div>
  </div>
);

AddPicture.propTypes = {
  addPicture: PropTypes.func.isRequired,
};

export default AddPicture;
